<div class="progress-container">
  @for (key of statusKeys; track key; let i = $index) {
    <div class="progress-step">
      <div class="circle" [class.active]="i + 1 <= (statusMap[displayStatus] || 0)">
        {{ i + 1 }}
      </div>
      <div class="label fw-bold text-uppercase" [class.text-success]="i < (statusMap[displayStatus] || 0)">{{ this.replaceUnderscoreWithSpace(key) }}</div>
      @if (i < statusKeys.length) {
        <div class="line" [class.active]="i < (statusMap[displayStatus] || 0)"
          [class.first-line]="i === 0" [class.last-line]="i === statusKeys.length - 1">
        </div>
      }
    </div>
  }
</div>